import { AssignAlbumsFnReq, AssignAlbumsFnRes } from '@uploadcam/common';
import { Functions, httpsCallable } from 'firebase/functions';
import { GetAuthDtoInteractor } from '../../../auth/domain/interactors/get-auth-dto.interactor';

export class AssignAlbumsInteractor {
  private readonly assignAlbumsFn = httpsCallable<AssignAlbumsFnReq, AssignAlbumsFnRes>(
    this.functions,
    'assignAlbums',
  );

  constructor(
    private readonly functions: Functions,
    private readonly getAuthDto: GetAuthDtoInteractor,
  ) {}

  public async execute(
    data: Omit<AssignAlbumsFnReq, 'auth'>,
  ): Promise<AssignAlbumsFnRes['result']> {
    const res = await this.assignAlbumsFn({
      ...data,
      auth: await this.getAuthDto.execute(),
    });

    return res.data.result;
  }
}
